var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconCogDouble2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28 9.37a1.31 1.31 0 0 0 1.94 0l.63-.7a1.3 1.3 0 0 1 2.27.95v.93a1.3 1.3 0 0 0 1.37 1.37l.94-.05a1.31 1.31 0 0 1 .94 2.28l-.7.62a1.33 1.33 0 0 0-.43 1 1.31 1.31 0 0 0 .43 1l.7.63a1.31 1.31 0 0 1 .33 1.47 1.3 1.3 0 0 1-1.27.8h-.94a1.3 1.3 0 0 0-1.37 1.37v.93a1.3 1.3 0 0 1-2.27.94l-.63-.69a1.31 1.31 0 0 0-1.94 0l-.63.69a1.3 1.3 0 0 1-2.27-.94v-.93a1.3 1.3 0 0 0-1.37-1.37h-.94a1.3 1.3 0 0 1-1.27-.8 1.31 1.31 0 0 1 .33-1.47l.7-.63a1.31 1.31 0 0 0 .43-1 1.33 1.33 0 0 0-.43-1l-.7-.62a1.31 1.31 0 0 1 .94-2.28l.94.05a1.3 1.3 0 0 0 1.37-1.37v-.93a1.3 1.3 0 0 1 2.27-.95Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 15.74,
    r: 1.88,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.26 5.25a.5.5 0 0 0-.5.5.5.5 0 0 0 1 0 .5.5 0 0 0-.5-.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 1.93a.8.8 0 0 1 .86.18.83.83 0 0 1 .19.87l-.54 1.39a.82.82 0 0 0 .24.93l1.25.93a.79.79 0 0 1 .27.84.8.8 0 0 1-.66.6l-1.47.22a.82.82 0 0 0-.68.68l-.23 1.48a.81.81 0 0 1-1.43.38l-.94-1.16a.79.79 0 0 0-.97-.27l-1.39.54a.81.81 0 0 1-1.05-1.05L15 7.12a.84.84 0 0 0-.25-.93l-1.17-.93A.82.82 0 0 1 14 3.82l1.47-.22a.82.82 0 0 0 .68-.68l.23-1.48a.83.83 0 0 1 .59-.66.82.82 0 0 1 .84.28l.94 1.16a.79.79 0 0 0 .92.25Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconCogDouble2);
export default __webpack_public_path__ + "static/media/streamline-icon-cog-double-2.f5d616ce.svg";
export { ForwardRef as ReactComponent };